import React from 'react';
import { Link } from 'react-router-dom';
import Modal from './Modal.js';
import loading_gif from '../Images/loading.gif';
import './UserSetup.css';

class UserSetup extends React.Component {
	constructor(props) {
		super(props);
		// State management:
		if (this.props.location.state) { // Allow stateful linking
			this.state = this.props.location.state;
		}
		else {
			this.state = {
				error: null,
				isLoaded: false,
				userList: [],
				activeModal: null,
				newUser: {},
				showNewUserModal: false
			};
		}
		
		// Function bindings:
		this.fetchInitialData = this.fetchInitialData.bind(this);
		this.activationChange = this.activationChange.bind(this);
		this.roleChange = this.roleChange.bind(this);
		this.newUserFn = this.newUserFn.bind(this);
		this.handleNewUserModalChange = this.handleNewUserModalChange.bind(this);
		this.removeUser = this.removeUser.bind(this);
	}
	
	// Gather information for initial page load
	fetchInitialData() {
		fetch('/webpub-services/WPUserOrganizationAPI/getWPUserOrganizationByOrganizationid/' + this.props.activeOrg, 
			{
				method: 'GET'
			}
		)
		.then(res => res.json())
		.then(
			(result) => {
				const sortedResult = result.sort((a, b) => {return a.wPUser.lastName.localeCompare(b.wPUser.lastName);});
				
				this.setState({
					isLoaded: true,
					error: null,
					userList: sortedResult
				});
			},
			
			(error) => {
				this.setState({
					isLoaded: false,
					error: error
				});
			}
		);
	}
	
	// Fires when user hits the lock/unlock icon. Should activate/deactivate the selected user.
	activationChange(userId) {
		// Actually, verify with user that they meant to do that
		const newModal = (
			<Modal>
				<div className='modal' aria-modal='true'>
					<div role='dialog' className='user-setup-modal'>
						<header>
							<span>Confirm</span>
							<button
								onClick={
									() => {
										this.setState({
											activeModal: null
										});
									}
								}
								type='button'
								aria-label='close'
							>
								X
							</button>
						</header>
							<div className='user-setup-modal-content' style={{textAlign: 'center'}} >
								Deactivated users cannot log into their accounts for ANY organization.<br />
								Please confirm that changing this user's active status is what you meant to do.
							</div>
						<footer>
							<button
								onClick={
									() => { // Alright. You asked for it.
										fetch('/webpub-services/WPUserAPI/updateWPUserActivation/' + userId, {method: 'PUT'})
										.then(res => res.json())
										.then(
											(result) => { // Request received.
												// I don't really know what we can expect here except success.
												this.setState({ 
													activeModal: null
												}, () => this.fetchInitialData());
											},
											
											(error) => { // something went wrong!
												this.setState({ 
													error: error, 
													isLoaded: false,
													activeModal: null
												});
											}
										);
									}
								}
								type='button'
								aria-label='confirm'
							>
								Confirm
							</button>
							<button 
								onClick={
									() => {
										this.setState({
											activeModal: null
										});
									}
								}
								type='button'
								aria-label='cancel' 
							>
								Cancel
							</button>
						</footer>
					</div>
				</div>
			</Modal>
		);
			
		this.setState({
			activeModal: newModal
		});
	}
	
	// Fires when the user hits the swappy arrows. Should turn the selected user into admins and vice versa.
	// If it somehow fires on a zero-permissions user, it gives them the user role
	roleChange(wpuserorgId) {
		const existingUserOrg = this.state.userList.filter((user) => parseInt(user.id) === parseInt(wpuserorgId))[0];
		let newAccessLevel = 1; // Default to User
		if (existingUserOrg.accessLevel === 0) {
			newAccessLevel = 1; // Nobody -> User, which shouldn't even be possible, but here we are
		}
		else if (existingUserOrg.accessLevel === 1) {
			newAccessLevel = 2; // User -> Admin
		}
		else if (existingUserOrg.accessLevel === 2) {
			newAccessLevel = 1; // Admin -> User
		}
		
		const newItem = {
			'accessLevel': newAccessLevel,
			'id': wpuserorgId,
			'organizationId': existingUserOrg.organizationId,
			'wpuserId': existingUserOrg.wpuserId
		};
		
		// Actually, verify with user that they meant to do that
		const newModal = (
			<Modal>
				<div className='modal' aria-modal='true'>
					<div role='dialog' className='user-setup-modal'>
						<header>
							<span>Confirm</span>
							<button
								onClick={
									() => {
										this.setState({
											activeModal: null
										});
									}
								}
								type='button'
								aria-label='close'
							>
								X
							</button>
						</header>
							<div className='user-setup-modal-content' style={{textAlign: 'center'}} >
								You are changing this user's role, which will change what the user is capable of doing
								in the WebPub system. Please verify that you intended to do that.
							</div>
						<footer>
							<button
								onClick={
									() => { // Alright. You asked for it.
										fetch('/webpub-services/WPUserOrganizationAPI/updateWPUserOrganization',
											{
												method: 'PUT',
												headers: {
													Accept: 'application/json',
													'Content-Type': 'application/json'
												},
												body: JSON.stringify(newItem)
											}
										)
										.then(res => res.json())
										.then(
											(result) => { // Request received.
												// I don't really know what we can expect here except success.
												this.setState({ 
													activeModal: null
												}, () => this.fetchInitialData());
											},
											
											(error) => { // something went wrong!
												this.setState({ 
													error: error, 
													isLoaded: false,
													activeModal: null													
												});
											}
										);
									}
								}
								type='button'
								aria-label='confirm'
							>
								Confirm
							</button>
							<button 
								onClick={
									() => {
										this.setState({
											activeModal: null
										});
									}
								}
								type='button'
								aria-label='cancel' 
							>
								Cancel
							</button>
						</footer>
					</div>
				</div>
			</Modal>
		);
			
		this.setState({
			activeModal: newModal
		});
	}
	
	// Reveals the new user modal (because of how React's virtual DOM works, the modal itself is defined in render() )
	newUserFn() {
		this.setState({
			showNewUserModal: true
		});
	}
	
	// User changed something in the new user modal. Reflect that in the state
	handleNewUserModalChange(changeEvent) {
		let newUserObj = this.state.newUser;
		newUserObj[changeEvent.target.id] = changeEvent.target.value;
		
		this.setState({
			newUser: newUserObj
		});
	}
	
	// Removes user's access from this org entirely
	removeUser(wpuserorgId) {
		// Double-check that this is for realsies
		const deleteUserModal = (
			<Modal>
				<div className='modal' aria-modal='true'>
					<div role='dialog' className='user-setup-modal'>
						<header>
							<span>Confirm Deletion</span>
							<button
								onClick={
									() => {
										this.setState({
											activeModal: null
										});
									}
								}
								type='button'
								aria-label='close'
							>
								X
							</button>
						</header>
							<div className='user-setup-modal-content' style={{textAlign: 'center'}} >
								You are removing this user's access to your active organization. 
								 <br />
								The user will no longer be able to post, edit, or view publications 
								for this organization.
								 <br />
								Please verify that you intended to do that.
							</div>
						<footer>
							<button
								onClick={
									() => { // Alright. You asked for it.
										fetch('/webpub-services/WPUserOrganizationAPI/deleteWPUserOrganizationById/' + wpuserorgId,
											{
												method: 'DELETE'
											}
										)
										.then(
											(result) => { // Request received.
												// I don't really know what we can expect here except success.
												this.setState({ 
													activeModal: null
												}, () => this.fetchInitialData());
											},
											
											(error) => { // something went wrong!
												this.setState({ 
													error: error, 
													isLoaded: false,
													activeModal: null													
												});
											}
										);
									}
								}
								type='button'
								aria-label='confirm'
							>
								Confirm
							</button>
							<button 
								onClick={
									() => {
										this.setState({
											activeModal: null
										});
									}
								}
								type='button'
								aria-label='cancel' 
							>
								Cancel
							</button>
						</footer>
					</div>
				</div>
			</Modal>
		);
		
		this.setState({
			activeModal: deleteUserModal
		});
	}
	
	// Initial page load
	componentDidMount() {
		if (this.props.userData && this.props.userData.id && this.props.activeOrg) {
			this.fetchInitialData();
		}
		else {
			this.setState({
				error: {message: 'Encountered a problem with user data. (US30)'}
			});
		}
	}
	
	render() {
		// Sanity checking
		if (this.state.error) {
			return <div className='error-text'>
				Error: {
					this.state.error.message 
					? this.state.error.message 
					: 'An unknown error has occurred (US12)'
				}
			</div>;
		} 
		else if (!this.state.isLoaded) { // Display nothing until we're ready for user input
			return <div>Loading <img src={loading_gif} alt='loading gif' style={{ verticalAlign: 'middle' }} /></div>;
		}
		
		const adminOrgs = this.props.userData.permissions.map((org) => {
			if (org.accessLevel >= 2) { // 0 is no access, 1 is read/submit, 2 is admin, 3 is a super-admin
				return parseInt(org.organizationId);
			}
			else {
				return null;
			}
		}).filter(item => item !== null);
		
		if (!adminOrgs.includes(parseInt(this.props.activeOrg))) { // TRESSPASSER!
			return (
				<div>
					<h2>Organization Setup</h2>
					<div className='error-text'>
						Error: You do not have permission to access User Setup for this organization.
					</div>
				</div>
			);
		}
		
		const userRows = this.state.userList.map((user) => {
			if (user.accessLevel === 0) return null; // Skip no-access users
			const permissionLevel = user.accessLevel >= 2 ? 'Admin' : 'User';
			
			// Style the row
			let rowClass = [];
			if (user.wPUser.active === false) {
				rowClass.push('inactive');
			}
			rowClass = rowClass.join(' '); // convert to string
			
			// Present icons
			let iconList = [];
			if (user.wPUser.active === false) {
				iconList.push(
					<span 
						className='ui-icon icon-unlock tooltip clickable' 
						key={'action-activate-' + user.wpuserId}
						onClick={() => {this.activationChange(user.wpuserId)}}
					>
						<span className='tooltiptext-bottom'>Activate User</span>
					</span>
				);
			}
			else {
				iconList.push(
					<span 
						className='ui-icon icon-lock tooltip clickable' 
						key={'action-deactivate-' + user.wpuserId}
						onClick={() => {this.activationChange(user.wpuserId)}}
					>
						<span className='tooltiptext-bottom'>Deactivate User</span>
					</span>
				);
			}
			
			iconList.push(
				<span 
					className='ui-icon icon-bold-swap-arrows tooltip clickable' 
					key={'action-role-' + user.wpuserId}
					onClick={() => {this.roleChange(user.id)}}
				>
					<span className='tooltiptext-bottom'>Change Role</span>
				</span>
			);
			
			iconList.push(
				<span 
					className='ui-icon icon-trash tooltip clickable' 
					key={'action-remove-' + user.wpuserId}
					onClick={() => {this.removeUser(user.id)}}
				>
					<span className='tooltiptext-bottom'>Remove User</span>
				</span>
			);
			
			return (
				<tr key={'usrow-' + user.wpuserId} className={rowClass} >
					<td style={{ textTransform: 'capitalize' }} >{permissionLevel}</td>
					<td style={{ textTransform: 'capitalize' }} >{user.wPUser.lastName}</td>
					<td style={{ textTransform: 'capitalize' }} >{user.wPUser.firstName}</td>
					<td>{user.wPUser.email}</td>
					<td>
						{user.wpuserId === this.props.userData.id ? null : iconList}
					</td>
				</tr>
			);
		}).filter(res => res !== null);
		
		// Spawn a modal with boxes if necessary, or else nothing
		// I know this is a huge block, but if it's not here, React doesn't recognize its changes. It's stupid, but that's life.
		// Search for MODALBOUND to find the other side of this declaration
		const newUserModal = this.state.showNewUserModal
		? (
			<Modal>
				<div className='modal' aria-modal='true'>
					<div role='dialog' className='user-setup-modal'>
						<header>
							<span style={{ marginLeft: 5, marginRight: 5 }}>Add New User</span>
							<button
								onClick={
									() => {
										this.setState({
											showNewUserModal: false,
											newUser: {}
										});
									}
								}
								type='button'
								aria-label='close'
							>
								X
							</button>
						</header>
						<div className='user-setup-modal-content' style={{textAlign: 'center'}} >
							<label 
								htmlFor='lastNameInput' 
								style={{display: 'block'}}
								className='user-setup-label'
							>
								Last Name
							</label>
							<input 
								type='text'
								id='lastName'
								maxLength={50}
								minLength={2}
								value={this.state.newUser.lastName || ''}
								onChange={this.handleNewUserModalChange}
							/>
							
							<label 
								htmlFor='firstNameInput' 
								style={{display: 'block'}}
								className='user-setup-label'
							>
								First Name
							</label>
							<input 
								type='text'
								id='firstName'
								maxLength={50}
								minLength={2}
								value={this.state.newUser.firstName || ''}
								onChange={this.handleNewUserModalChange}
							/>
							
							<label 
								htmlFor='emailInput' 
								style={{display: 'block'}}
								className='user-setup-label'
							>
								Email
							</label>
							<input 
								type='email'
								id='email'
								maxLength={50}
								minLength={5}
								value={this.state.newUser.email || ''}
								onChange={this.handleNewUserModalChange}
							/>
							<br/>
							{ this.state.newUser.errorMsg 
								? this.state.newUser.errorMsg.map(reason => {
									return <div key={'reason-' + reason}>{reason}</div>;
								}) 
								: ''
							}
						</div>
						<footer>
							<button
								onClick={
									() => { // Save button
										// Validate inputs
										let newUserObj = this.state.newUser;
										delete newUserObj.error; // If there's an error, we'll find it again
										let errorArray = [];
										if (
											!newUserObj.firstName
											|| !newUserObj.firstName.length
											|| newUserObj.firstName.length < 2
											|| newUserObj.firstName.length > 50
											) {
											errorArray.push('First Name field unacceptable');
										}
										if (
											!newUserObj.lastName
											|| !newUserObj.lastName.length 
											|| newUserObj.lastName.length < 2 
											|| newUserObj.lastName.length > 50
											) {
											errorArray.push('Last Name field unacceptable');
										}
										if (
											!newUserObj.email
											|| !newUserObj.email.length 
											|| newUserObj.email.length < 5 
											|| newUserObj.email.length > 50
											) {
											errorArray.push('Email field unacceptable');
										}
										if (errorArray.length) {
											newUserObj.errorMsg = errorArray;
											this.setState({
												newUser: newUserObj
											});
											return;
										}
										
										// Sanity check: Is user already in our fetched list?
										const matchArr = this.state.userList.filter((user) => user.wPUser.email === newUserObj.email);
										if (matchArr.length) {
											// Because if so, go home, user. You're drunk.
											newUserObj.errorMsg = ['A user with that email address already exists at this organization.'];
											this.setState({
												newUser: newUserObj
											});
											return;
										}
										
										// Prepare yourself. These fetch requests chain pretty hard.
										// Check if user already exists in database
										fetch('/webpub-services/WPUserAPI/getWPUserByEmail/' + newUserObj.email)
										.then(res => res.json())
										.then(
											(result) => { // Request received.
												if (result.length === 0) {
													newUserObj.createdUser = this.props.userData.id;
													newUserObj.createdDate = new Date();
													newUserObj.modifiedUser = this.props.userData.id;
													newUserObj.modifiedDate = new Date();
													newUserObj.startOrg = this.props.activeOrg;
													newUserObj.active = true;
													// Case 1: User doesn't exist
													// Create user
													fetch('/webpub-services/WPUserAPI/createWPUser', 
													{
														method: 'PUT',
														headers: {
															Accept: 'application/json',
															'Content-Type': 'application/json'
														},
														body: JSON.stringify(newUserObj)
													})
													.then(
														(result) => { // Request received.
															if (parseInt(result.status) !== 200) { // Request rejected!
																const newErrMsg = result.statusText ? result.status + ': ' + result.statusText : 'An unknown error occurred (US629)';
																newUserObj.errorMsg = [newErrMsg];
																this.setState({
																	newUser: newUserObj
																});
																return; // Fail out now, since we can't be sure this step actually happened.
															}
															
															// Request accepted
															// Get id because create doesn't return one
															fetch('/webpub-services/WPUserAPI/getWPUserByEmail/' + newUserObj.email)
															.then(res => res.json())
															.then(
																(result) => {
																	// Give user permissions for the activeOrg
																	const userId = result[0].id;
																	
																	fetch('/webpub-services/WPUserOrganizationAPI/createWPUserOrganization', 
																	{
																		method: 'POST',
																		headers: {
																			Accept: 'application/json',
																			'Content-Type': 'application/json'
																		},
																		body: JSON.stringify({
																			accessLevel: 1,
																			organizationId: this.props.activeOrg,
																			wpuserId: userId
																		})
																	})
																	.then(() => {
																		// I'm assuming the user/org association worked.
																		// Send a password setup email to the user:
																		fetch('/webpub-services/auth/requestPasswordSetup',
																			{
																				method: 'PUT',
																				headers: {
																					Accept: 'application/json',
																					'Content-Type': 'application/json'
																				},
																				body: JSON.stringify({
																					userEmail: newUserObj.email,
																					url: window.location.protocol + '//' + window.location.hostname // try to be environment-agnostic
																				})
																			}
																		);
																		// Close the modal
																		this.setState({
																			showNewUserModal: false,
																			newUser: {}
																		}, () => this.fetchInitialData());
																	});
																}, 
																
																(error) => { // something went wrong!
																	const newErrMsg = error.message ? error.message : 'An unknown error occurred (US535)';
																	newUserObj.errorMsg = [newErrMsg];
																	this.setState({
																		newUser: newUserObj
																	});
																	return;
																}
															);
														},
														
														(error) => { // something went wrong!
															const newErrMsg = error.message ? error.message : 'An unknown error occurred (US532)';
															newUserObj.errorMsg = [newErrMsg];
															this.setState({
																newUser: newUserObj
															});
															return;
														}
													);
														
												}
												else {
													const userId = result[0].id;
													// Case 2: User exists already
													
													// Give them user access to the activeOrg
													fetch('/webpub-services/WPUserOrganizationAPI/createWPUserOrganization', 
													{
														method: 'POST',
														headers: {
															Accept: 'application/json',
															'Content-Type': 'application/json'
														},
														body: JSON.stringify({
															accessLevel: 1,
															organizationId: this.props.activeOrg,
															wpuserId: userId
														})
													})
													.then(() => {
														// I'm assuming this worked.
														// Close the modal
														this.setState({
															showNewUserModal: false,
															newUser: {}
														}, () => this.fetchInitialData());
													});
												}
											},
											
											(error) => {
												const newErrMsg = error.message ? error.message : 'An unknown error occurred (US512)';
												newUserObj.errorMsg = [newErrMsg];
												this.setState({
													newUser: newUserObj
												});
												return;
											}
										);
									}
								}
								type='button'
								aria-label='confirm'
							>
								Save
							</button>
							<button 
								onClick={
									() => { // Cancel button
										this.setState({
											showNewUserModal: false,
											newUser: {}
										});
									}
								}
								type='button'
								aria-label='cancel' 
							>
								Cancel
							</button>
						</footer>
					</div>
				</div>
			</Modal>
		) : null;
		// Search for MODALBOUND to find the other side of this declaration
		
		return (
			<div>
				<h2>Organization Setup: View, Add, and Edit Organizations, Webpages, and Users</h2>
				<p>
					<Link 
						to={{
							pathname: '/organizations'
						}}
						className='nav-button'
						style={{ borderColor: 'black' }}
					>
						Organizations & Webpages
					</Link>
					<span style={{ paddingLeft: 15 }} />
					<b
						className='nav-button active'
						style={{ borderColor: 'black' }}
					>Users</b> 
				</p>
				<div>
					<table className='user-setup-table' >
						<thead className='user-setup-head-row' >
							<tr>
								<th className='user-setup-header' >Level</th>
								<th className='user-setup-header' >Last Name</th>
								<th className='user-setup-header' >First Name</th>
								<th className='user-setup-header' >Email</th>
								<th className='user-setup-header' >Actions</th>
							</tr>
						</thead>
						<tbody>
							{userRows}
						</tbody>
						<tfoot>
							{/*paginationContent*/}
						</tfoot>
					</table>
				</div>
				{this.state.activeModal}
				{newUserModal}
				<div style={{paddingTop: 15, textAlign: 'right' }} >
					<span
						onClick={ 
							() => { // Hi there! This is the Add User button.
								this.newUserFn();
							}
						}
						type='button'
						aria-label='add new user'
						className='user-setup-new-user-button clickable'
					>
						Add User
					</span>
				</div>
			</div>
		);
	}
}

export default UserSetup;